import textCategoryList from "./textCategoryList";
import textList from "./textList";

export default `
${textList}
${textCategoryList}
`;
